import HttpData from "@/http/data/http-data";
import QrServerLogEntryData, {IQrServerLogEntryApiData} from "@/http/data/qr-server-log-entry-data";
import QrServerLogFiltersData, {IQrServerLogFiltersData} from "@/http/data/qr-server-log-filters-data";

export interface IQrServerLogLinksApiData {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
}

export interface IQrServerLogMetaLinkApiData {
    url: string | null;
    label: string;
    active: boolean;
}

export interface IQrServerLogMetaApiData {
    current_page: number;
    from: number;
    last_page: number;
    links: IQrServerLogMetaLinkApiData[];
    path: string;
    per_page: number;
    to: number;
    total: number;
}

export interface IQrServerLogPageApiData {
    data: IQrServerLogEntryApiData[];
    links: IQrServerLogLinksApiData;
    meta: IQrServerLogMetaApiData;
    filters: IQrServerLogFiltersData;
}

export interface QrServerLogLinksData {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
}

export interface QrServerLogMetaLinkData {
    url: string | null;
    label: string;
    active: boolean;
}

export interface QrServerLogMetaData {
    currentPage: number;
    from: number;
    lastPage: number;
    links: QrServerLogMetaLinkData[];
    path: string;
    perPage: number;
    to: number;
    total: number;
}

export default class QrServerLogPageData extends HttpData {
    public data: QrServerLogEntryData[];
    public links: QrServerLogLinksData;
    public meta: QrServerLogMetaData;
    public filters: QrServerLogFiltersData;

    constructor(data: IQrServerLogPageApiData) {
        super();

        this.data = data.data.map(item => new QrServerLogEntryData(item));
        this.links = {
            first: data.links.first,
            last: data.links.last,
            prev: data.links.prev,
            next: data.links.next
        };
        this.meta = {
            currentPage: data.meta.current_page,
            from: data.meta.from,
            lastPage: data.meta.last_page,
            links: data.meta.links.map(link => ({
                url: link.url,
                label: link.label,
                active: link.active
            })),
            path: data.meta.path,
            perPage: data.meta.per_page,
            to: data.meta.to,
            total: data.meta.total
        };
        this.filters = new QrServerLogFiltersData(data.filters);
    }
}
